import { useEffect, useState } from "react";
import api from "../API/Api";
import "../housestyle.css";
import "./SeasonInfo.css";
import "../Home/Home.css";
import DiscordMarkdown from "../components/DiscordMarkdown";

const VIDEO = "https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/background_vids/vid_2.mp4";
const HYPE_START = "2026-02-01T00:00:00";

function useCountdown(targetDate) {
  const calc = () => {
    if (!targetDate) return { days: 0, hours: 0, minutes: 0, seconds: 0, ended: false };
    const diff = new Date(targetDate) - new Date();
    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, ended: true };
    return {
      days: Math.floor(diff / 86400000),
      hours: Math.floor((diff % 86400000) / 3600000),
      minutes: Math.floor((diff % 3600000) / 60000),
      seconds: Math.floor((diff % 60000) / 1000),
      ended: false,
    };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => {
    if (!targetDate) return;
    const t = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(t);
  }, [targetDate]);
  return time;
}

function autoProgress(launchDate) {
  const start = new Date(HYPE_START).getTime();
  const end = new Date(launchDate).getTime();
  const now = Date.now();
  if (now >= end) return 100;
  if (now <= start) return 0;
  return Math.round(((now - start) / (end - start)) * 100);
}

function formatLaunchFriendly(iso) {
  if (!iso) return "TBD";
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })
    + " · " + d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
}

function NewsCard({ item }) {
  const isOffer = item.type === 'offer';
  return (
    <div className={`home-news-card ${isOffer ? 'home-news-card--offer' : ''} ${item.image_url ? 'home-news-card--has-img' : ''}`}>
      <div className="home-news-content">
        <div className="home-news-header">
          <span className={`home-news-badge ${item.type}`}>
            {isOffer ? 'Limited Offer' : item.type}
          </span>
          <span className="home-news-date">
            {new Date(item.created_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
          </span>
        </div>
        <h3>{item.title}</h3>
        <DiscordMarkdown text={item.content} className="home-news-body" />
        <div className="home-news-footer">
          <span className="home-news-author">By {item.author || 'Staff'}</span>
        </div>
      </div>
      {item.image_url && (
        <div className="home-news-img">
          <img src={item.image_url} alt={item.title} />
        </div>
      )}
    </div>
  );
}

export default function SeasonInfo() {
  const [season, setSeason] = useState(null);
  const [news, setNews] = useState([]);

  useEffect(() => {
    api("getseasoninfo").then((res) => {
      if (res.isSuccess) setSeason(res.data);
    });
    api("getnews").then((res) => {
      if (res.isSuccess) setNews(res.data || []);
    });
  }, []);

  const launchDate = season?.start_date ?? null;
  const countdown = useCountdown(launchDate);
  const progress = season
    ? (season.progress !== null && season.progress !== undefined
      ? Number(season.progress)
      : autoProgress(launchDate))
    : 0;
  const workingOn = season?.working_on ?? [];
  const isLive = season?.is_live === "1" || season?.is_live === 1;
  const launchLabel = launchDate ? formatLaunchFriendly(launchDate) : "NULL";

  return (
    <>
      <div className="si-hero">
        <video className="si-hero-video" src={VIDEO} autoPlay muted loop playsInline />
        <div className="si-hero-overlay" />
        <div className="si-hero-content container">

          <div className="si-hero-eyebrow">Current Season</div>
          <h1 className="si-hero-title">Season <em>{season?.number ?? 1}</em></h1>

          <div className="si-hero-launch-label">
            Expected launch &mdash; <span>{launchLabel}</span>
          </div>

          {/* Countdown */}
          {isLive ? (
            <div className="si-hero-live-badge">Season {season?.number ?? 1} is LIVE — play.simplemcnetwork.net</div>
          ) : !countdown.ended ? (
            <div className="si-hero-countdown">
              {[
                ["Days", countdown.days],
                ["Hours", countdown.hours],
                ["Minutes", countdown.minutes],
                ["Seconds", countdown.seconds],
              ].map(([label, val]) => (
                <div key={label} className="si-cd-block">
                  <span className="si-cd-val">{String(val).padStart(2, "0")}</span>
                  <span className="si-cd-label">{label}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="si-hero-live-badge">Season {season?.number ?? 1} is LIVE — play.simplemcnetwork.net</div>
          )}

          <div className="si-hero-progress-wrap">
            <div className="si-hero-progress-bar">
              <div className="si-hero-progress-fill" style={{ width: `${progress}%` }} />
            </div>
            <span className="si-hero-progress-pct">{progress}%</span>
          </div>
          <p className="si-hero-progress-note">Estimated launch progress</p>

          {workingOn.length > 0 && (
            <div className="si-working-on">
              <span className="si-working-label">Currently working on</span>
              {workingOn.map((item) => (
                <span key={item} className="si-working-chip">{item}</span>
              ))}
            </div>
          )}

        </div>
      </div>

      <div className="container section">
        <div className="section-label">
          <span className="sl-text">Latest News & Offers</span>
        </div>
        {news.length > 0 ? (
          <div className="home-news-grid">
            {news.slice(0, 3).map(item => <NewsCard key={item.id} item={item} />)}
          </div>
        ) : (
          <div className="home-news-empty">
            <p>No news or offers at the moment. Check back soon!</p>
          </div>
        )}
      </div>
    </>
  );
}
